import request from './adminRequest'

const uploadApi = {
  uploadImage (data, config) {
    return request.post('/file/upload', data, config)
  },
  uploadExcel (data) {
    return request.post('/upload/excel', data)
  },
  uploadPDF (data) {
    return request.post('/upload/pdf', data)
  },
  uploadCareerExcel(data) {
    return request.post('/upload/CareerExcel', data)
  },
}

export default uploadApi
